/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import { animate, style, transition, trigger } from "@angular/animations";
import {
	ChangeDetectionStrategy,
	Component,
	ViewContainerRef,
	input,
	output,
	viewChild
} from "@angular/core";
import {
	type NotificationAction,
	NotificationComponent,
} from "../notification/notification.component";

@Component({
	selector: "cb-toast",

	imports: [NotificationComponent],
	templateUrl: "./toast.component.html",
	styleUrl: "./toast.component.scss",
	animations: [
		trigger("toast", [
			transition(":enter", [
				style({ bottom: "-500px", transform: "scale(0.9)" }),
				animate(
					"300ms ease-out",
					style({ bottom: "1rem", transform: "scale(1)" }),
				),
			]),
			transition(":leave", [
				style({ bottom: "1rem", transform: "scale(1)" }),
				animate(
					"300ms ease-out",
					style({ bottom: "-500px", transform: "scale(0.9)" }),
				),
			]),
		]),
	],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent {
	readonly notificationContainer = viewChild.required("NotificationContainer", { read: ViewContainerRef });

	public readonly notification = input.required<{
		key: string;
		title: string;
		message: string;
		icon?: string;
		color: "brand" | "success" | "warning" | "error" | "info" | "gray";
		hierarchy: "secondary" | "tertiary";
		actions?: NotificationAction[];
		image?: string;
		imageStyle?: "thumbnail" | "preview";
	} | undefined>();

	public readonly onClose = output();

	public onActionClicked(action: NotificationAction): void {
		action.callback();
	}

	public close(): void {
		setTimeout(() => {
			this.onClose.emit();
		}, 300);
	}
}
